<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 p-2 mb-0">
          <div class="row justify-content-between align-items-center">
            <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-xl-3 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <label for="page_quantity" class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                  <select id="page_quantity" class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <button type="button" class="btn btn-outline-primary" (click)="selectedProduct = null; _utilService.popupOpenProductForm = true" *ngIf="_authenticationService.hasCapability('create_product')">
                {{ "ADD" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 150"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterProductsList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'name', dir: 'asc' }]"
          >
            <ngx-datatable-column [name]="'NAME' | translate" prop="name" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <a routerLink="/dashboard/product/{{ row.id }}">{{ row.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRICE' | translate" prop="monthly_amount" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ _utilService.addDotsToNumber(row.monthly_amount) }} €</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRESUMED_TOTAL_MONTHLY_COST' | translate" prop="monthly_cost" *ngIf="_utilService.isDesktop" [width]="auto">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ _utilService.addDotsToNumber(row.monthly_cost) }} €</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-secondary" (click)="goEdit(row)" [ngbTooltip]="'EDIT' | translate" *ngIf="_authenticationService.hasCapability('edit_product')">
                    <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="_authenticationService.hasCapability('delete_product')">
                    <span [data-feather]="'trash-2'" size="16"></span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- mobile - tablet -->
            <ngx-datatable-column [name]="'NAME' | translate" prop="name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <a routerLink="/dashboard/product/{{ row.id }}">{{ row.name }}</a>
                  </div>
                  <div class="col-12">
                    <span>{{ "PRICE" | translate }}:</span>
                    <span class="ml-025">{{ _utilService.addDotsToNumber(row.monthly_cost) }} €</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "PRESUMED_TOTAL_MONTHLY_COST" | translate }}:</span>
                    <span class="ml-025">{{ _utilService.addDotsToNumber(row.monthly_amount) }} €</span>
                  </div>
                  <div class="col-12 d-flex">
                    <button class="bg-transparent border-0 text-secondary ml-auto" (click)="goEdit(row)" *ngIf="_authenticationService.hasCapability('edit_product')">
                      <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                    </button>
                    <button class="bg-transparent border-0 text-danger mr-2" (click)="delete(row)" *ngIf="_authenticationService.hasCapability('delete_product')">
                      <span [data-feather]="'trash-2'" size="16"></span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>

<app-product-form [selectedProduct]="this.selectedProduct" (updateList)="loadProducts()" *ngIf="_utilService.moduleIsActive('products') && _utilService.popupOpenProductForm"></app-product-form>
